// extracted by mini-css-extract-plugin
module.exports = {"boxContainer":"PleaseWaitBox_boxContainer__2YXRm","headerPart":"PleaseWaitBox_headerPart__1b4DR"};